import { AUTH_API_ENDPOINTS } from '@/constants';
import { api } from '@/services';

import {
  IAuthProfile,
  LoginWithUserNamePasswordPayload,
  OTPLoginPayload,
} from '@/features/logins/interfaces';
import { ApiResponse } from '@/types';

const LoginService = {
  LoginWithUserNamePassword: async (payload: LoginWithUserNamePasswordPayload): Promise<void> => {
    await api.post(AUTH_API_ENDPOINTS.AUTH_LOGIN, payload);
  },
  Logout: async (): Promise<void> => {
    await api.get(AUTH_API_ENDPOINTS.AUTH_LOGOUT);
  },
  SendOTP: async (email: string): Promise<ApiResponse<string>> => {
    const response = await api.post<ApiResponse<string>>(
      AUTH_API_ENDPOINTS.AUTH_SEND_OTP.replace(':email', email),
    );
    return response.data;
  },
  ResendOTP: async (email: string): Promise<ApiResponse<string>> => {
    const response = await api.post<ApiResponse<string>>(
      AUTH_API_ENDPOINTS.AUTH_RESEND_OTP.replace(':email', email),
    );
    return response.data;
  },
  VerifyOTP: async (payload: OTPLoginPayload): Promise<ApiResponse<void>> => {
    const response = await api.post<ApiResponse<void>>(
      AUTH_API_ENDPOINTS.AUTH_VERIFY_OTP.replace(':email', payload.email)
        .replace(':otp', payload.otp)
        .replace(':scope', payload.scope),
    );
    return response.data;
  },
  GetCurrentProfile: async (): Promise<ApiResponse<IAuthProfile>> => {
    const response = await api.get<ApiResponse<IAuthProfile>>(AUTH_API_ENDPOINTS.AUTH_PROFILE);
    return response.data;
  },
};

export default LoginService;
